import React, { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { adminApi, formatApiError } from "@/context/AdminAuthContext";
import { imgSrc } from "@/lib/img";
import { Field, Input } from "@/admin/ui";

export const ImageUpload = ({ value, onChange, testId = "image-upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await adminApi.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err, "Upload failed"));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div>
      <span className="block text-[11px] font-bold uppercase tracking-[0.14em] text-forest/70 mb-1.5">Product image</span>
      <div className="flex gap-4 items-start">
        <div className="w-28 h-28 rounded-xl overflow-hidden bg-creamdark border border-forest/10 shrink-0 flex items-center justify-center">
          {value ? <img src={imgSrc(value)} alt="" className="w-full h-full object-cover" /> : <span className="text-[10px] text-mutedgreen">No image</span>}
        </div>
        <div className="flex-1 space-y-2">
          <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid={`${testId}-input`} onChange={(e) => upload(e.target.files?.[0])} />
          <button type="button" data-testid={`${testId}-button`} disabled={busy} onClick={() => ref.current?.click()} className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] px-4 py-2.5 rounded-full border border-forest/20 text-forest hover:bg-forest/5 transition-colors disabled:opacity-60">
            {busy ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />} {busy ? "Uploading…" : "Upload image"}
          </button>
          <Field label="or image path / URL" className="!mt-3">
            <div className="flex gap-2">
              <Input data-testid={`${testId}-path`} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="/images/moringa-powder.png" />
              {value && <button type="button" onClick={() => onChange("")} className="p-2 text-mutedgreen hover:text-red-700"><X size={15} /></button>}
            </div>
          </Field>
          <p className="text-[11px] text-mutedgreen">JPG, PNG or WEBP · up to 5 MB</p>
        </div>
      </div>
    </div>
  );
};
